// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';
import {twMerge} from 'tailwind-merge';

import {useGoToBaseUrl} from '../../Panel/hooks/hooks';
import {useViewBarContext} from '../NamedWorkspaceViewBarContext';
import {NamedWorkspaceMenuItem} from '../types';
import {NamedWorkspaceMenuItemComp} from './NamedWorkspaceMenuItem';

type NamedWorkspaceMenuGroupProps = {
  options: NamedWorkspaceMenuItem[];
  defaultMaxItems: number;
  testId?: string;
};

export const NamedWorkspaceMenuGroup = ({
  options,
  defaultMaxItems,
  testId,
}: NamedWorkspaceMenuGroupProps) => {
  const {currentWorkspaceViewRef, onMenuItemClick} = useViewBarContext();
  const [shouldShowAll, setShouldShowAll] = useState(false);

  const dropdownItems =
    !shouldShowAll && options.length > defaultMaxItems
      ? options.slice(0, defaultMaxItems)
      : options;
  const goToBaseURL = useGoToBaseUrl();

  return (
    <>
      <DropdownMenu.Group>
        {dropdownItems.map(option => {
          return (
            <DropdownMenu.CheckboxItem
              key={
                option.viewCid + option.namedWorkspaceId.id + option.optionType
              }
              id={option.namedWorkspaceId.id}
              className="items-start text-moon-800 dark:text-moon-300"
              checked={currentWorkspaceViewRef.id === option.viewCid}
              data-test={testId}
              onClick={() => {
                onMenuItemClick(option.viewCid, option.namedWorkspaceId);
                goToBaseURL();
              }}>
              <NamedWorkspaceMenuItemComp option={option} />
              <DropdownMenu.ItemIndicator>
                <Icon name="checkmark" width={18} height={18} />
              </DropdownMenu.ItemIndicator>
            </DropdownMenu.CheckboxItem>
          );
        })}
      </DropdownMenu.Group>
      {options.length > defaultMaxItems && (
        <p
          className={twMerge(
            'my-6 ml-[3rem] cursor-pointer text-base font-semibold leading-[24px]',
            'text-teal-600 hover:text-teal-550',
            'dark:text-teal-400 dark:hover:text-teal-450'
          )}
          onClick={() => setShouldShowAll(prev => !prev)}>
          {shouldShowAll ? 'Show less' : 'Show all'}
        </p>
      )}
    </>
  );
};
